// extracted by mini-css-extract-plugin
export default {"claim-tabs-wrapper":"claimTabs_claim-tabs-wrapper__XLf1e"};